module.exports = __webpack_public_path__ + "static/First-02-35379da3ec182b433b3565c9ae801440.jpg";